import { get as networkGet, patch as networkPatch } from '../../networkClient';
import { Path } from '../path';

const toErrorShape = error => ({
  error: true,
  message: error?.response?.data?.error || error?.message || 'Request failed',
  status: error?.response?.status
});

// Replaces the `getAllSopAndAnnouncement` GraphQL query. Server returns
// { data: [...] } — no pagination, matching the legacy resolver.
// Multi-id params are sent comma-separated (?clients=a,b,c), which is the
// project convention and what the REST endpoint's Joi schema validates.
export async function getSopAndAnnouncements({
  clients = [],
  apartments = [],
  isImportant,
  searchWord
} = {}) {
  const response = await networkGet(
    Path.SOP_ANNOUNCEMENTS,
    {
      clients: clients.length ? clients.join(',') : undefined,
      apartments: apartments.length ? apartments.join(',') : undefined,
      isImportant,
      searchWord
    },
    null,
    true,
    true
  );
  if (response?.isAxiosError || response?.response) {
    return toErrorShape(response);
  }
  return response?.data;
}

// Replaces `getAgentAnnouncements`.
export async function getAgentAnnouncements() {
  const response = await networkGet(
    Path.SOP_ANNOUNCEMENTS_FOR_AGENT,
    null,
    null,
    true,
    true
  );
  if (response?.isAxiosError || response?.response) {
    return toErrorShape(response);
  }
  return response?.data;
}

// Replaces `updateSopAcknowledgement`. `ids` is the list of SOP/announcement
// _ids to acknowledge for the current user.
export async function acknowledgeSopAnnouncements(ids) {
  try {
    const response = await networkPatch(
      Path.SOP_ANNOUNCEMENTS_ACKNOWLEDGE,
      { ids },
      null,
      null,
      true,
      true
    );
    return response?.data;
  } catch (error) {
    return toErrorShape(error);
  }
}
